<ng-container *ngIf="applications">
  <div class="container-fluid g-0" style="margin: 15px 10px; max-width: 100%">
    <div class="row">
      <h1>Applications</h1>
      <p>Showing application/s. {{ applications.length }}</p>
    </div>
    <div class="my-2" *ngIf="evaluatorDetails.officeName === 'CMO'">
      <button
        mat-raised-button
        color="primary"
        (click)="approveAll()"
        [disabled]="isLoading"
      >
        {{ isLoading ? "Submitting.." : "Approve All" }}
      </button>
    </div>
  </div>

  <div class="container-fluid" style="margin-bottom: 1rem">
    <div class="row">
      <div class="col-lg-6">
        <mat-form-field appearance="outline" [style.width.%]="100">
          <mat-label>Search</mat-label>
          <input
            matInput
            appCharactersOnly
            appNoLeadingSpaces
            placeholder="Search"
            [formControl]="searchControl"
          />
        </mat-form-field>
      </div>
      <div class="col-lg-3">
        <mat-form-field appearance="outline" [style.width.%]="100">
          <mat-label>Filter by Work Permit Type</mat-label>
          <mat-select [formControl]="workPermitTypeControl">
            <mat-option value="">All Types</mat-option>
            <mat-option value="1">Food Handler</mat-option>
            <mat-option value="2">Non Food Handler</mat-option>
            <mat-option value="3">Entertainer (Female)</mat-option>
            <mat-option value="4">Entertainer (Male)</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-lg-2 d-flex align-items-center">
        <mat-form-field appearance="outline" [style.width.%]="100" class="me-2">
          <mat-label>Filter by Date</mat-label>
          <input
            matInput
            [matDatepicker]="picker"
            [formControl]="dateControl"
            placeholder="Choose a date"
            [max]="maxDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
            style="color: #00943a"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <div>
          <mat-icon
            style="
              cursor: pointer;
              margin-left: 0px;
              margin-bottom: 15px;
              color: #00943a;
            "
            (click)="resetDateFilter()"
          >
            update
          </mat-icon>
        </div>
      </div>

      <div class="col-lg-6">
        <!-- <div class="d-flex justify-content-end">
          <button
            mat-raised-button
            color="primary"
            class="text-white"
            style="height: 55px; width: 105px"
          >
            Filter
          </button>
        </div> -->
      </div>
    </div>
  </div>
  <mat-card
    *ngFor="let application of paginatedData"
    style="width: 100%; margin-bottom: 1rem"
  >
    <mat-card-content style="padding: 1rem; height: auto">
      <div class="row">
        <div class="col-lg-1">
          <div class="d-flex justify-content-center">
            <img
              *ngIf="application.workingPermitType == '1'"
              src="/assets/yellow-card.png"
              width="65px"
              height="75px"
              alt=""
              srcset=""
              class="text-center mt-3"
            />
            <img
              *ngIf="application.workingPermitType == '2'"
              src="/assets/green-card.png"
              width="65px"
              height="75px"
              alt=""
              srcset=""
              class="text-center mt-3"
              style="margin-top: 2rem"
            />
            <img
              *ngIf="application.workingPermitType == '3'"
              src="/assets/pink-card.png"
              width="65px"
              height="75px"
              alt=""
              srcset=""
              class="text-center mt-3"
              style="margin-top: 2rem"
            />
            <img
              *ngIf="application.workingPermitType == '4'"
              src="/assets/blue-card.png"
              width="65px"
              height="75px"
              alt=""
              srcset=""
              class="text-center mt-3"
              style="margin-top: 2rem"
            />
          </div>
        </div>
        <div class="col-lg-6">
          <div class="col-lg-12" style="font-size: 15px">
            <mat-label>
              {{ application.applicationTypeName?.split("Permit")[0] }} Permit -
              {{
                application.workingPermitTypeName === "Food Handler"
                  ? "Food"
                  : application.workingPermitTypeName === "Entertainer (Female)"
                  ? "Entertainer (Female)"
                  : application.workingPermitTypeName === "Entertainer (Male)"
                  ? "Entertainer (Male)"
                  : "Non Food"
              }}
            </mat-label>
          </div>
          <div class="col-lg-12 mb-2">
            <div class="user-container">
              <mat-label class="label" style="color: #4caf50">{{
                application.apn
              }}</mat-label>
            </div>
          </div>
          <div class="col-lg-12 mb-2">
            <div class="col-lg-12 mb-2">
              <div class="user-container">
                <mat-icon style="color: #198754">person</mat-icon>
                <mat-label style="margin-left: 5px">{{
                  application.applicantName
                }}</mat-label>
              </div>
            </div>
          </div>
          <div class="col-lg-12 mb-2">
            <div class="user-container">
              <mat-icon
                style="color: #198754; font-size: 20px; margin-left: 2px"
                >work</mat-icon
              >
              <span style="margin-left: 5px"
                >{{
                  getOccupation(
                    application.workingPermitType,
                    application.occupation
                  )
                }}
              </span>
            </div>
          </div>
          <div class="col-lg-12 mb-2">
            <div class="user-container">
              <mat-icon style="color: #198754">location_city</mat-icon>
              <mat-label style="margin-left: 5px"
                >{{ application.occupationEstablishment }},
                {{ application.occupationEstablishmentAddress }}</mat-label
              >
            </div>
          </div>
          <div class="col-lg-12 mb-2"></div>
          <!-- <div class="col-lg-12 mb-2">
            <div class="user-container">
              <img src="/assets/contract.png" alt="" srcset="" />
              <mat-label style="margin-left: 5px"
                ><strong>Returned to applicant </strong> by lorem ipsum on
                <strong> lorem ispum</strong></mat-label
              >
            </div>
          </div> -->
        </div>
        <div class="col-lg-5">
          <div class="col-lg-12">
            <div class="d-flex justify-content-end"></div>
            <div class="d-flex justify-content-end">
              <mat-label style="color: #c0c0c0"
                >Submitted:
                {{ application.createdDate | date : "longDate" }}</mat-label
              >
              <!-- <p>{{ application.applicationStatusName }}</p>     -->
            </div>
            <div class="d-flex justify-content-end">
              <mat-label class="label"
                >Status:
                <!-- {{ application.applicationStatusDisplayName }}
                   -->
                <span
                  [ngClass]="{
                    'status-PE':
                      application.applicationStatusDisplayName ===
                      'Parallel Evaluation',
                    'status-FPE':
                      application.applicationStatusDisplayName ===
                      'For PESO Evaluation',
                    'status-FS':
                      application.applicationStatusDisplayName ===
                      'For Signature',
                    'status-FR':
                      application.applicationStatusDisplayName ===
                      'For Releasing',
                    'status-inc':
                      application.applicationStatusDisplayName === 'Incomplete',
                    'status-Released':
                      application.applicationStatusDisplayName === 'Released'
                  }"
                >
                  {{ application.applicationStatusDisplayName }}
                </span>
              </mat-label>
            </div>
          </div>
          <div class="col-lg-12" style="margin-top: 2.5rem">
            <div class="d-flex justify-content-end">
              <div class="row g-0">
                <div class="col-lg-12">
                  <button
                    mat-raised-button
                    color="primary"
                    class="text-white"
                    (click)="viewApplication(application)"
                  >
                    View
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <!-- MatPaginator directive -->
  <mat-paginator
    [length]="applications.length"
    [pageSize]="pageSize"
    [pageIndex]="pageIndex"
    (page)="handlePageEvent($event)"
    showFirstLastButtons
    aria-label="Select page"
  >
  </mat-paginator>
</ng-container>
